<template>
  <div class="layout-form-feedback px-5 py-16 mt-2 text-center text-white bg-gradient-to-b from-[#3D4A6C] to-[#192647] rounded-xl">
    <div class="max-w-[1500px] mx-auto sm:flex gap-12 justify-between">
      <div class="text-left">
        <div class="text-2xl font-semibold uppercase">
          Остались вопросы?
        </div>
        <div class="my-2 text-5xl font-semibold uppercase">
          Перезвоним<br> и всё раскажем
        </div>
        <div class="max-w-md mt-8 text-lg">
          Оставьте контактные данные справа, мы свяжемся с Вами в ближайшее время или выберите другой канал связи:
        </div>
        <div class="flex gap-2 mt-6">
          <a :href="'https://t.me/'+telegram">
            <img class="w-12 h-auto cursor-pointer" src="/images/lp-telegram.svg" alt="">
          </a>
          <a :href="'https://wa.me/'+whthsapp">
            <img class="w-12 h-auto cursor-pointer" src="/images/lp-whatsapp.svg" alt="">
          </a>
        </div>
      </div>
      <!--  -->
      <div class="text-center w-[460px] max-w-full mt-6 sm:mt-0">
        <div v-if="opened">
          <div class="mb-5 text-base font-bold">Введите контактные данные</div>
          <div class="grid grid-cols-2 gap-3">
            <input v-model="name" required placeholder="Иванов Адрей Васильевич" type="text"
                   :class="[{ 'error': errorName }, 'h-12 col-span-2 text-base font-medium text-white bg-transparent border-2 border-white border-solid']"
                   @focus="onfocus(errorEmail)"
            >
            <input @focus="errorBorder" v-model="phone" class="ui-input" :class="[{ 'error': errorPhone }, 'h-12 text-base font-medium text-white bg-transparent border-2 border-white border-solid']" type="tel" placeholder="Введите телефон" required />
<!--            <phone-mask-input
                v-model="phone"
                autoDetectCountry
                @onValidate="onValidate"
                :inputClass="[{ 'error': errorPhone }, 'h-12 text-base font-medium text-white bg-transparent border-2 border-white border-solid']"
                placeholder=""
                required
            />-->
            <input v-model="email" required placeholder="ivanov@email.ru" type="email" inputmode="email"
                   :class="[{ 'error': errorEmail }, 'h-12 text-base font-medium text-white bg-transparent border-2 border-white border-solid']"
                   @focus="onfocus(errorEmail)"
                   >
          </div>
          <ui-button @click="sendFeedback('Получить консультацию')" class="w-full mt-8" white>Получить консультацию</ui-button>
          <div class="mt-4 text-sm opacity-60">
            Оставляя контактные данные и нажимая на кнопку, Вы соглашатесь с политикой обработки персональных данных
          </div>
        </div>
        <div class="success" v-else>
          <icon-success class="animated zoomIn"></icon-success>
          <div class="s-30 w-500">Заявка отправлена</div>
          <div v-if="subText" class="s-16">Ожидайте, когда менеджер с вами свяжется</div>
          <ui-button @click="close">Закрыть окно</ui-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'ui-button': () => import('@/components/ui/ui-button'),
    'icon-success': () => import('@/components/icon/icon-success'),
  },
  data(){
    return {
      telegram: this.$store.state.langs.TELEGRAM,
      whthsapp: this.$store.state.langs.WHTHSAPP,
      name: "",
      phone: "",
      email: "",
      opened: true,
      sended: false,
      validPhone: false,
      errorPhone: false,
      errorName: false,
      errorEmail: false
    }
  },
  methods: {
    sendFeedback( text ) {
      /*if( !this.validPhone ){this.errorPhone=true;return false;}*/

      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      if( this.name==="" ){this.errorName=true;return false;}
      if( this.email==="" ){this.errorEmail=true;return false;}
      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: "",
          email: "",
          phone: this.phone,
          text: text,
          header: text,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );
          this.sended = true;
          this.opened = false;
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'consult_brand_request_sentForm');
          }
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
    close(){
      this.sended = false;
      this.opened = true;
    },
    onValidate(ev){
      this.errorPhone=false;
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    onfocus(errorEv){
      this[errorEv]=false;
    }
  },
  errorBorder(){
    const phoneError = document.querySelector('input[type="tel"]');
    if(phoneError) {
      phoneError.classList.remove('error');
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-form-feedback {}
.success {
  svg {
    margin: 2em auto;
  }
  .ui-button {
    margin-top: 4em;
  }
}
</style>
<style lang="scss">
  .error {
    border: 1px solid #ccc;
    animation: border 2s linear infinite;
  }

  @keyframes border {
    0% { border-color: red; }
    50% { border-color: rgb(0, 255, 242); }
    100% { border-color: lime; }
  }
</style>
